import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="pt-24 pb-20 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#64748B] hover:text-[#14B8A6] font-body mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>

        <h1 data-testid="privacy-policy-title" className="font-heading text-3xl md:text-4xl font-bold text-[#0F172A] mb-8">Privacy Policy</h1>
        <p className="text-sm text-[#64748B] font-body mb-8">Last updated: December 2025</p>

        <div className="prose prose-slate max-w-none font-body space-y-6 text-[#475569] text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">1. Consent and Information Collection</h2>
            <p>
              By using the Carecrony.com website or app, you agree that we collect basic details (like your name, email, phone, address, and property info) and sometimes sensitive data (like payment details) to provide and improve services, personalize communication, and handle deliveries.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">2. Information Sharing</h2>
            <p>
              We may share information with drivers, third parties for technical reasons, or if required by law. We implement industry-standard protections to keep your data secure. We do not sell your personal data to third parties.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">3. Data Retention</h2>
            <p>
              Data is retained while you use our services and for a reasonable time afterward. This ensures we can provide consistent service and maintain necessary business records.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">4. Cookies and External Links</h2>
            <p>
              Cookies may be used to improve your experience and analyze site traffic. Our website may contain links to external sites, which have their own privacy rules; we are not responsible for the privacy practices of those external websites.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">5. Grievance Redressal & Jurisdiction</h2>
            <p>
              Any concerns or grievances can be raised with our Grievance Officer. All disputes related to this policy fall under Indian law and are subject to the jurisdiction of courts in Pune, Maharashtra.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8 mb-3">6. Contact Us</h2>
            <p>For any privacy-related concerns, contact us at:</p>
            <p className="mt-2">Email: <a href="mailto:support@carecrony.com" className="text-[#14B8A6] hover:underline">support@carecrony.com</a></p>
            <p>Phone: <a href="tel:+919270425109" className="text-[#14B8A6] hover:underline">+91 9270425109</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
